import React, {Component} from 'react';
import {FormGroup, Input, Label,} from 'reactstrap';

import './RatingMultiResponse.scss';
import './RatingResponse.scss';
import AutoTextarea from "../../forms/AutoTextarea";

class PtoRatingMultiResponse extends Component {

  constructor(props) {
    super(props);

    this.state = {}
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    this.handleCommentInput(this.props.value.observationComment)
  }


  // ----------------------
  // Methods
  // ----------------------


  handleCommentInput(value) {
    const valueObject = {
      ...this.props.value,
      observationComment: value,
    };

    valueObject.isValid = this.props.disableOitComment || !!value;

    this.props.onValueChange(this.props.name, valueObject);
  }

  handleTimeSpendInput(value) {

    const valueObject = {
      ...this.props.value,
      timeSpend: value
    };

    this.props.onValueChange(this.props.name, valueObject);
  }


  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="rating-response rating-multi-response">
        <Label style={{whiteSpace: 'pre-wrap'}}>{this.props.ratingPrompt}</Label>
        <div className="rating-multi-fields-container">
          {
            <div>
              <FormGroup>
                <AutoTextarea
                  className={(this.props.value.touched && !this.props.value.isValid) ? 'is-invalid' : ''}
                  value={this.props.value.observationComment}
                  placeholder="Observation comment"
                  onChange={(value) => this.handleCommentInput(value)}
                />
              </FormGroup>
              {!this.props.disableOitComment && <div className="text-danger small">Comment is required</div>}
            </div>
          }
          {this.props.hasTimeSpendField && (
            <div style={{maxWidth: '600px'}}>
              <FormGroup>
                <label>
                  {this.props.timeSpendFieldPrompt || 'If remedial training occurred, list minutes spend'}
                </label>
                <Input
                  onBlur={event => this.handleTimeSpendInput(event.target.value)}
                  onChange={event => this.handleTimeSpendInput(event.target.value)}
                  type="text"
                  placeholder="Time spend"
                  value={this.props.value.timeSpend}
                />
              </FormGroup>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PtoRatingMultiResponse;

